import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import Input from './form-elements/input';

const propTypes = {
	form: PropTypes.string.isRequired,
	placeholder: PropTypes.string,
	action: PropTypes.func,
	autoFocus: PropTypes.bool,
	intl: PropTypes.func
};

const defaultProps = {
	autoFocus: false,
	placeholder: 'Поиск'
};

const Main = props => (
	<div className="search-bar">
		<form action="#" onSubmit={e => { e.preventDefault(); props.action(); }}>
			<Field name="search" placeholder={props.intl(props.placeholder)} component={Input} autoFocus={props.autoFocus}/>
		</form>
	</div>
);

Main.propTypes = propTypes;
Main.defaultProps = defaultProps;

export default reduxForm({})(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/search.js